<template>
    <div class="full-width" :style="pageStyle" v-loading="loading">

        <div v-show="props.viewPart === 'order'">
          <div v-if="myUtil.isNotEmpty(pageObj.total)">
            <el-row style="padding-bottom: 10px;">
              <el-col :span="8">
                <span>{{i18n.tkey('lang_Total_order_quantity')}}：{{pageObj.total}}</span>
              </el-col>
              <el-col :span="8">
                <span>{{i18n.tkey('lang_Total_amount')}}：{{pageObj.totalSum}}</span>
              </el-col>
              <el-col :span="8">
                <span>{{i18n.tkey('lang_Confirm_the_total_amount')}}：{{pageObj.vtotalSum}}</span>
              </el-col>

            </el-row>
          </div>
          <el-row v-if="myUtil.isNotEmpty(props.editObj)" style="padding-bottom: 10px;">
            <el-col :span="8">
              <span>{{i18n.tkey('lang_Total_views')}}：{{browseNum}}</span>
            </el-col>
            <el-col :span="16">
            </el-col>

          </el-row>
            <hallorderList :list="datalist" v-if="datalist != null &&datalist.length > 0"
                           @clickGoDetail="goDetail"
                           @clickDelete = "clickDeleteRef"
            />
          <div v-if="edatalist != null &&edatalist.length > 0" >
            <div v-for="(obj, i) in edatalist" :key="obj.CommonRef">
              <div class="full-width" ref="billDetailDom">

                <el-row :gutter="10" style=" padding: 8px;" >
                  <el-col :span="cols" class="info-parts" @click="eGoDetail(obj)" >
                    <br>
                    <span style="color: #1a9aef">{{obj.CommonRef}}</span>
                    <span>-{{obj.clientCompanyCode}}</span>
                  </el-col>
                  <el-col :span="cols" class="info-parts">

                    <span>{{obj.Name}}</span><br>
                    <span>{{obj.Telephone}}</span><br>
                    <span>{{obj.Email}}</span>
                  </el-col>
                  <el-col :span="cols" class="info-parts">
                    <br>
                    <span>{{obj.OrderDate}}</span>
                  </el-col>

                  <el-col :span="cols" class="info-parts">
                    <span>{{obj.PaymentMethod}}</span><br>
                    <span> {{obj.BOCurr}} {{obj.TotalSum}}</span>
                  </el-col>

                  <el-col :span="cols" class="info-parts">

                    <span v-if="(obj.Verify === '-1')"  style="color:#24bb6f;">order {{i18n.tkey("lang_certified") }} </span>
                    <span v-if="(obj.Verify !== '-1')" >order {{ i18n.tkey("lang_not_certified")}} </span>
                    <br>
                    <span v-if="(obj.PaymentVerify === '-1')"  style="color:#24bb6f;">pay {{i18n.tkey("lang_certified") }} </span>
                    <span v-if="(obj.PaymentVerify !== '-1')" >pay {{ i18n.tkey("lang_not_certified")}} </span>
                    <!--          <el-text type="primary" style="padding-left:8px; " tkey="查看">{{i18n.tkey("lang_jump_to_view")}}</el-text>-->
                  </el-col>

                </el-row>
              </div>

            </div>
          </div>

            <div>
                <el-empty :description="i18n.tkey('lang_temporary_no_data')" v-if="(datalist == null || datalist.length < 1)&&(edatalist == null || edatalist.length < 1)">

                </el-empty>
            </div>

          <paginationComponent v-if="myUtil.isNotEmpty(pageObj.endRow)" :pageObj="pageObj" @goPage="changePage" />
        </div>
        <div v-if="props.viewPart === 'orderInfo'">
          <orderDetail  style="padding: 0 16px" v-if="null != detailObj&&datalist != null &&datalist.length > 0"
                        :obj="detailObj"
                        :fromdata="fromdata"
                        @changeOrder="changeOrderInfo"
                        @clickVerify="clickVerifyRef"

          />
          <eOrderDetail  style="padding: 0 16px" v-if="null != detailObj&&edatalist != null &&edatalist.length > 0"
                        :obj="detailObj"
                        :fromdata="fromdata"
                        @changeOrder="changeOrderInfo"
                        @clickVerify="clickVerifyRef"
                         @clickPayVerify="clickPayVerifyRef"

          />
        </div>

    </div>
</template>

<script setup>
import {inject, onBeforeMount, provide, ref, toRef, getCurrentInstance, onMounted} from "vue";
    import {useUserinfo} from "@/stores/userinfo";
    import myUtil from "@/util/util";
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import {faDownload} from '@fortawesome/free-solid-svg-icons'
    import boApi from "@/request/boApi";
    import HallorderList from "@/components/shopchart/hallorderList.vue";
    import OrderDetail from "@/components/shopchart/orderDetail.vue";
    import record15Api from "@/request/record15Api";
    import eshopopeeApi from "@/request/eshopopeeApi";
    import HallOrderRecord from "@/components/shopchart/hallOrderRecord.vue";
import EOrderDetail from "@/components/shopchart/eOrderDetail.vue";
import PaginationComponent from "@/components/shopopee/common/paginationComponent.vue";
import record12Api from "@/request/record12Api";

    library.add(faDownload)

    const props = defineProps(["editObj","fromdata","viewPart"])
    const { proxy } = getCurrentInstance()
    const emits = defineEmits(["clickChangeViewPart"])
    const detailObj = ref(null)
    const fromdata = ref('order')

    const userInfoRef = toRef(useUserinfo())
    const i18n = inject("i18n")
    const loading = ref(false)
    const pageStyle = ref(null)
    const pageObj = ref({})
    const addinfo23 = ref("")
    const cols = ref(24)
    const browseNum = ref(0)
    let pageNum = 1
    let pageSize = 10

    //const { goDisplayIndexView } = inject('phoneView', { goDisplayIndexView: () => { proxy.$router.push({name: "home"} )} })

    const datalist = ref([])
    const edatalist = ref([])


    function getOrderList(){
        const request = boApi.queryHallBoByPage
        const params = request.getParams()
        if(props.editObj!=null){
          params.companycode = userInfoRef.value.companycode
          params.orderref = props.editObj.id
        }else {
          params.addinfo3 = userInfoRef.value.login
          params.japno = 6
        }
        params.pageNum = pageNum
        params.pageSize = pageSize

        request.send(params, (res) => {
          if (res.code == 200){
            const obj = res.detail
            pageObj.value = obj
            datalist.value = res.detail.list

          }else{
            myUtil.alertError(res.msg)
          }
        })

    }

    function queryAdditionalrecord12(){
      const request = record12Api.queryAdditionalrecord12
      const params = request.getParams()


      params.addinfo1 = props.editObj.id

      request.send(params, (res) => {
        if (res.code == 200){

          for (let i = 0; i < res.detail.length; i++) {
            browseNum.value += res.detail[i].updatedid
          }
        }else{
          myUtil.alertError(res.msg)
        }
      })
    }

    function changePage(num){
      pageNum = num
      getOrderList()
    }


    function goDetail(ref, companycode){
      //   printRef.value = ref
      //   printCompanyCode.value = companycode

      getOrderInof(ref)
    }

    function clickDeleteRef(ref){
      deleteOrderInof(ref)
    }
    function changeOrderInfo(){

    }

    function clickVerifyRef(obj,Verify){
      console.log(obj)
      console.log(addinfo23.value === "1")
      if (addinfo23.value === "1"){
        updateEOrderInof(obj,Verify)
      }else{
        updateOrderInof(Verify)
      }

    }

    function clickPayVerifyRef(obj,Verify){
      //updateOrderInof(Verify)
      if (addinfo23.value === "1"){
        updateEPaymentInof(obj,Verify)
      }
    }

    function updateEOrderInof(obj,Verify){
      const request = eshopopeeApi.updateBOState
      const params = request.getParams()

      params.CompanyCode = obj.clientCompanyCode
      params.CommonRef = obj.CommonRef
      params.Verify = Verify
      request.send(params, (res) => {
        if (res.code == 200){
          detailObj.value.Verify = Verify
          for (let i = 0; i < edatalist.value.length; i++) {
            if(edatalist.value[i].CommonRef===detailObj.value.CommonRef){
              edatalist.value[i].Verify = Verify
              return
            }
          }
        }else{
          myUtil.alertError(res.msg)
        }
      })
    }

function updateEPaymentInof(obj,Verify){
  const request = eshopopeeApi.updatePaymentState
  const params = request.getParams()

  params.CompanyCode = obj.clientCompanyCode
  params.CommonRef = obj.CommonRef
  params.Verify = Verify
  request.send(params, (res) => {
    if (res.code == 200){
      detailObj.value.PaymentVerify = Verify
      for (let i = 0; i < edatalist.value.length; i++) {
        if(edatalist.value[i].CommonRef===detailObj.value.CommonRef){
          edatalist.value[i].PaymentVerify = Verify
          return
        }
      }
    }else{
      myUtil.alertError(res.msg)
    }
  })
}


    function updateOrderInof(Verify){
      const request = boApi.updateBoVerify
      const params = request.getParams()

      params.id = detailObj.value.id
      params.verify = Verify
      request.send(params, (res) => {
        if (res.code == 200){
          detailObj.value.verify = Verify
          for (let i = 0; i < datalist.value.length; i++) {
            if(datalist.value[i].id===detailObj.value.id){
              datalist.value[i].verify = Verify
              return
            }
          }
        }else{
          myUtil.alertError(res.msg)
        }
      })
    }

    function deleteOrderInof(ref){
      myUtil.confirmWarning(i18n.tkey("lang_delete_confirm"), () => {
        loading.value = true

        const request = boApi.delBo
        const params = request.getParams()

        params.commonref = 0
        params.id = ref

        request.send(params, (res) => {
          loading.value = false
          if (res.code == 200){
            myUtil.alertSuccess(i18n.tkey("lang_delete_success"))
            changePage(1)
          }else{
            myUtil.alertError(res.msg)
          }
        })
      })
    }

    function getOrderInof(orderID){
      const request = boApi.queryBoDetail
      const params = request.getParams()

      params.id = orderID

      request.send(params, (res) => {
        if (res.code == 200){
          detailObj.value = res.detail

          emits("clickChangeViewPart", "orderInfo")
        }else{
          myUtil.alertError(res.msg)
        }
      })
    }

    function eGoDetail(obj){

      detailObj.value = obj

      emits("clickChangeViewPart", "orderInfo")
    }

    function getHallRecord15ByPage(){
      loading.value = true

      const request = record15Api.getRecord15ListandCompanyByPage
      const params = request.getParams()

      params.recordno = null
      params.updatedid = props.editObj.id
      params.pageNum = 1
      params.pageSize = 1000

      request.send(params, (res) => {
        loading.value = false

        if (res.code == 200){
          const obj = res.detail

          let companyCodelist = ""
           obj.list
          companyCodelist = ""
          obj.list.forEach((v, i) => {
            companyCodelist+= `'${v.company.acccompanycode}',`
          })
          if(companyCodelist.length>1){
            companyCodelist = companyCodelist.slice(0, -1);
          }
          if(companyCodelist.length>1){
            getBOAll(companyCodelist)
          }
        }else{
          myUtil.alertError(res.msg)
        }
      })


    }


    //訂單數
    function getBOAll(companyCode) {
      const request = eshopopeeApi.getBOAll
      const params = request.getParams()
      params.CompanyCode = companyCode
      params.startTime = props.editObj.addinfo3
      params.endTime = props.editObj.addinfo4
      request.send(params, (res) => {
        console.log(res)
        if (res.code == 200) {
          edatalist.value = res.data
          pageObj.value = res.pageObj
        }
      })
    }

    onBeforeMount(() => {
      if(props.fromdata === "myHallOrder"){
        fromdata.value = ""
      }
      if(myUtil.isNotEmpty(props.editObj)){
        addinfo23.value = props.editObj.addinfo23
      }

      console.log(props.editObj)
      if (addinfo23.value === "1"){
        getHallRecord15ByPage()
      }else{
        changePage(1)
      }

    })

onMounted(() => {
  if (myUtil.isMobile()){
    cols.value = 12
  }else{
    cols.value = 4
  }
  if(props.editObj!=null){
    queryAdditionalrecord12()
  }

})

</script>

<style scoped>
    .full-width {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        overflow-x: hidden;
        overflow-y: auto;
        text-align: left;
    }

    .title-operation-part {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 50px;
        box-sizing: border-box;
        padding: 0 10px;
    }

    .page-main-part {
        width: 100%;
        height: calc(100% - 50px);
        box-sizing: border-box;
    }

    .page-title-span {
        font-size: 18px;
        font-weight: 600;
        color: #303133;
    }

    .paddding-part {
        padding: 10px;
    }
</style>